import { MODEL_TYPE } from "../utils/enums";

export function locationModel(data) {
  return {
    latitude: data ? (data.latitude || data.lat) : 0,
    longitude: data ? (data.longitude || data.lng) : 0,
    modelType: MODEL_TYPE.location
  };
}
